import React        from 'react';
import {
  reduxForm,
  Field,
}                   from 'redux-form';
import SubmitButton from 'components/ui/form/submit_button';
import Title        from 'components/ui/titles';

const DataRectificationRequestForm = ({ submitting, handleSubmit }) => (
  <React.Fragment>
    <Title
      size="h3"
      className="uk-text-center"
    >
      { t('gdpr.options.data_rectification_requests') }
    </Title>
    <p>{ t('gdpr.data_rectification_requests.show.info_1') }</p>
    <p>{ t('gdpr.data_rectification_requests.show.info_2') }</p>
    <form onSubmit={ handleSubmit } className="mt-20">
      <Field
        type="text"
        name="message"
        component="textarea"
        className="uk-textarea"
        required
      />
      <SubmitButton
        className="mt-20"
        type="submit"
        loading={ submitting }
      />
    </form>
  </React.Fragment>
);

export default reduxForm({
  form: 'rectification_request',
})(DataRectificationRequestForm);
